/**
 * @generated SignedSource<<22dc3af805c4ddd42cd998c272679c37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SingleChoiceRenderer_question$data = {
  readonly id: string;
  readonly options: ReadonlyArray<{
    readonly label: string;
    readonly subValue: string | null | undefined;
    readonly sublabel: string | null | undefined;
    readonly value: string;
  }>;
  readonly " $fragmentType": "SingleChoiceRenderer_question";
};
export type SingleChoiceRenderer_question$key = {
  readonly " $data"?: SingleChoiceRenderer_question$data;
  readonly " $fragmentSpreads": FragmentRefs<"SingleChoiceRenderer_question">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SingleChoiceRenderer_question",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Option",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sublabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subValue",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Question",
  "abstractKey": null
};

(node as any).hash = "bdb8ed79877716e2b99d9985131d5cc6";

export default node;
